import { render } from "./UserPage.vue?vue&type=template&id=1f617f2a&scoped=true"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"

import "./UserPage.vue?vue&type=style&index=0&id=1f617f2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f617f2a"]])

export default __exports__